/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type expiringPromoMessageHelpers_user = {
    readonly expiringPromotion: {
        readonly daysRelativeToExpiration: string | null;
        readonly promotionMeta: {
            readonly urgencyMessagingDisplay: boolean | null;
            readonly urgencyMessagingDaysBeforeExpiration: number | null;
        } | null;
    } | null;
    readonly " $refType": "expiringPromoMessageHelpers_user";
};
export type expiringPromoMessageHelpers_user$data = expiringPromoMessageHelpers_user;
export type expiringPromoMessageHelpers_user$key = {
    readonly " $data"?: expiringPromoMessageHelpers_user$data;
    readonly " $fragmentRefs": FragmentRefs<"expiringPromoMessageHelpers_user">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "expiringPromoMessageHelpers_user"
};
(node as any).hash = 'e48d659647645bfcf6e4f580795cfe62';
export default node;
